export default {
  // Reviews
  "edit_review": "Modifier l'avis",
  "review": "Avis",
  "film_friendly_score": "Score de compatibilité argentique",
  "hand_check": "Vérification manuelle",
  "successful": "Réussie",
  "unsuccessful": "Non réussie",
  "delete_review": "Supprimer l'avis",
  "review_by": "Avis par",
  "Terminal": "Terminal",
};
